import { openBlock as e, createElementBlock as m, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function z(n, H) {
  return e(), m("svg", o, [...H[0] || (H[0] = [
    t("path", {
      fill: "currentColor",
      d: "M20.667 20H4V4h16.667zm-8-.667H16v-2.666h-3.333zm-8 0H8v-2.666H4.667zm4 0H12v-2.666H8.667zm8 0H20v-2.666h-3.333zM4.667 16H8v-3.333H4.667zm4 0H12v-3.333H8.667zm8 0H20v-3.333h-3.333zm-4 0H16v-3.333h-3.333zm-8-4H8V8.667H4.667zm4 0H12V8.667H8.667zm8 0H20V8.667h-3.333zm-4 0H16V8.667h-3.333zm-8-4H8V4.667H4.667zm4 0H12V4.667H8.667zm8 0H20V4.667h-3.333zm-4 0H16V4.667h-3.333z"
    }, null, -1)
  ])]);
}
const l = { render: z };
export {
  l as default,
  z as render
};
